import { deleteRequest } from '..';

const deleteSolveTag = (assetId: string, tagId: string) => deleteRequest(
  `assets/${assetId}/solve-tags/${tagId}`,
);

export default deleteSolveTag;
